import { TypographySize } from '@/components/typography/enums/size';
import type { DefaultTheme } from 'styled-components';

export const getLinkSize = (theme: DefaultTheme, size?: TypographySize): string => {
  switch (size) {
    case TypographySize.Small:
      return theme.typography.fontSize[2];
    case TypographySize.Large:
      return theme.typography.fontSize[4];
    default:
      return theme.typography.fontSize[3];
  }
};
